<template>
    <div class="sigleproduct">
		<loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
        <CommonHead></CommonHead>       
        <b-modal
        id="cart_notificaion"
        ref="cartmodal"
        :title="this.cartOrderMsg"
        title-tag="h3"
        ok-only
        modal-class="common_pop cart_notificaion">
        </b-modal>
	
        <!-- Save to projects pop up -->
        <b-modal
            id="saveto-project"
            ref="modal"
            title="Save to Projects"
            title-tag="h3"
            ok-only
            modal-class="common_pop saveto_project">
            <div v-if="!showclient && !shownewproject && !shownewclient" class="projectoptions">
                <h3>Save to Projects</h3>
                <ul>
                    <li><a href="javascript:;" @click="showclient = !showclient">Existing Client - Existing Project</a></li>
                    <li><a href="javascript:;" @click="shownewproject = !shownewproject">Existing Client - New Project</a></li>
                    <li><a href="javascript:;" @click="shownewclient = !shownewclient">New Client- New Project</a></li>
                </ul>
            </div>
                <div v-if="showclient" class="savetoclient">
                    <a @click="(showclient = !showclient); resetModelForm();" href="javascript:;"><b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back</a>
                    <h3>Save to Existing Client- Project</h3>
					<b-form class="commonform" @submit="Submit1Popup">
						<div class="row">
						  <div class="col" :state="!form1.errors.has('client')" :class="form1.errors.get('client')?'haserror forstar':'forstar'"
                            :invalid-feedback="form1.errors.get('client')">
							<label class="setuplabel">Select a Client</label>
							<div class="md-field md-theme-default">
							<v-select :state="!form1.errors.has('client')"
                                @input="form1.errors.clear('client'); getProjects();"
								:options="clientscart"
								:reduce="clientscart => clientscart.value"
								label="text"
										v-model="form1.client"
										placeholder="">
							</v-select>
							<span class="error-msg" v-if="form1.errors.get('client')">Required Field</span>
							</div>
						  </div>
						</div>
						<div class="row showProject">
						  <div class="col" :state="!form1.errors.has('project')" :class="form1.errors.get('project')?'haserror forstar':'forstar'"
                            :invalid-feedback="form1.errors.get('project')">
							<label class="setuplabel">Select a Project</label>
							<div class="md-field md-theme-default">
							<v-select :state="!form1.errors.has('project')"
                                @input="form1.errors.clear('project')" :options="projects"
								:reduce="projects => projects.value"
								label="text"
										v-model="form1.project"
										placeholder="">
							</v-select>
							<span class="error-msg" v-if="form1.errors.get('project')">Required Field</span>
							</div>
						  </div>
						</div>
                    <b-button block type="submit" variant="dark">Add</b-button>
					<span class="error-msg" v-if="this.form1.error_name!=''">{{this.form1.error_name}}</span>
					</b-form>
                </div>
                <div v-if="shownewproject" class="savetoclient">
                    <a @click="(shownewproject = !shownewproject); resetModelForm();" href="javascript:;"><b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back</a>
                    <h3>Save to New Project of Existing Client</h3>
					<b-form class="commonform" @submit="Submit2Popup">
						<div class="row">
						  <div class="col" :state="!form2.errors.has('client_id')" :class="form2.errors.get('client_id')?'haserror forstar':'forstar'"
                            :invalid-feedback="form2.errors.get('client_id')">
							<label class="setuplabel">Select a Client</label>
							<div class="md-field md-theme-default">
							<v-select :state="!form2.errors.has('client_id')"
                                @input="form2.errors.clear('client_id'); showProject1();" :options="clientscart"
								:reduce="clientscart => clientscart.value"
								label="text"
										v-model="form2.client_id"
										placeholder="">
							</v-select>
							<span class="error-msg" v-if="form2.errors.get('client_id')">Required Field</span>
							</div>
						  </div>
						</div>
						<div class="row showProject1">
						  <div class="col">
							<md-field :state="!form2.errors.has('name')" :class="form2.errors.get('name')?'haserror forstar':'forstar'"
                            :invalid-feedback="form2.errors.get('name')">
							<label class="setuplabel">Create and save to new project</label>
							<md-input :state="!form2.errors.has('name')"
                                @input="form2.errors.clear('name')" v-model="form2.name"></md-input>
							
							<span class="error-msg" v-if="form2.errors.get('name')">{{form2.errors.get('name')=="The name field is required."?'Required Field':form2.errors.get('name')}}</span>
						  </md-field>
						  </div>
						</div>
						<b-button block type="submit" variant="dark">Add</b-button>
						<span class="error-msg" v-if="this.form2.error_name!=''">{{this.form2.error_name}}</span>
					</b-form>
                </div>
                <div v-if="shownewclient" class="savetoclient newcreation">
                    <a @click="(shownewclient = !shownewclient); resetModelForm();" href="javascript:;"><b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back</a>
                    <h3>Save to New Client- Project</h3>
                    <b-form class="commonform" @submit="Submit3Popup">
                        <md-field :state="!form.errors.has('createclient')" :class="form.errors.get('createclient')?'haserror forstar':'forstar'"
                            :invalid-feedback="form.errors.get('createclient')">
                            <label>Create a new client</label>
                            <md-input :state="!form.errors.has('createclient')"
                                @input="form.errors.clear('createclient'); showProject2();" v-model="form.createclient"></md-input>
							<span class="error-msg" v-if="form.errors.get('createclient')">{{form.errors.get('createclient')=="The createclient field is required."?'Required Field':form.errors.get('createclient')}}</span>
						</md-field>
                        <md-field :state="!form.errors.has('createproject')" :class="form.errors.get('createproject')?'haserror forstar showProject2':'forstar showProject2'"
                            :invalid-feedback="form.errors.get('createproject')">
                            <label>Create a new project</label>
                            <md-input :state="!form.errors.has('createproject')"
                                @input="form.errors.clear('createproject')" v-model="form.createproject"></md-input>
							<span class="error-msg" v-if="form.errors.get('createproject')">{{form.errors.get('createproject')=="The createproject field is required."?'Required Field':form.errors.get('createproject')}}</span>
                        </md-field>
                        <b-button block type="submit" variant="dark">Add</b-button>
						<span class="error-msg" v-if="this.form.error_name!=''">{{this.form.error_name}}</span>
                    </b-form>
                </div>
        </b-modal>
		
		<b-modal
		  id="success-save-project"
		  ref="successmodal"
		  :title="this.successtitle"
		  title-tag="h3"
		  ok-only
		  modal-class="common_pop save_project"
		>
		</b-modal>
	
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
            <div class="singleproductdetails">
                <div class="singleimage">
                    <div class="positionset" v-if="is_dataloaded == true">
                        <div class="highlight">
                            <vue-magnifier :src="info.SRCSMALL" :src-large="info.SRCLARGE" />
                            <a :href="info.SRCLARGE" download class="downloadimg" v-b-tooltip.hover title="Download Image"><b-img class="download" src="/shop/images/download.svg" fluid alt="download image"></b-img></a>
                        </div>
                        <div class="smallimages" v-if="info.PRODUCTIMAGES.length > 1" >
                            <a v-for="(proimg,pik) in info.PRODUCTIMAGES" :key="pik" href="javascript:;" class="forborder"><b-img class="smallimg" :src="proimg.MEDIUM_IMAGE" fluid alt="product6 image"></b-img></a>
                        </div>
                    </div>
                </div>
                <div class="singlecontent">
                    <h2 data-v-singlehardware>{{info.ITEMNAME?info.ITEMNAME:''}} / {{info.COLORNAME}}</h2>
                    <a v-if="user.id > 0" class="printdetails" @click="getPDF()" href="javascript:;"><b-img class="print" src="/shop/images/print.svg" fluid alt="print image"></b-img>Print Details</a>
                    <div class="pricesection" v-if="user.id > 0">
                        <div class="samediv" v-if="user.setting_retail === false">
                            <span>Wholesale Price :</span>
                            <p>$ {{parseFloat(info.PRICE).toFixed(2)}}</p>
                        </div>
                    </div>
					<div class="detailed-options">
						<ul class="new_ul">
							<li><a href="javascript:;" v-b-toggle.specifications>Specifications <b-img class="addicon" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img></a>
								<b-collapse visible id="specifications" accordion="my-accordion_specifications">
									<div class="specification">
										<div class="spec_cont">
											<div class="spec_details" v-if="user.id > 0">
												<div class="lblspec"><span>ITEMID:</span></div>
												<div class="txtspec"><p>{{info.ITEMID}}</p></div>
											</div>
											<div class="spec_details">
												<p>{{info.DESCRIPTION}}</p>
											</div>
											<div class="spec_details" v-if="user.id > 0">
												<p>Effective September 1, 2019, a 10% tariff surcharge is being applied to all Paris Texas Hardware, The Finial Company, Aria, and Finestra products. This surcharge is not reflected on rmcoco.com or any retail price list. 10% must be added to current pricing shown.</p>
											</div>
										</div>
									</div>
								</b-collapse>
							</li>
							<li class="diff_li">
								<div class="fixedbar">
									  <div class="container">
										<div class="beforesignin" v-if="user.id<=0">
										  <h3>To place orders please sign in or register</h3>
										  <div class="buttonsdiv">
											  <b-button href="/shop/login" variant="dark">Sign in</b-button>
											  <b-button href="/apply/" variant="dark">Register</b-button>
										  </div>
										</div>
							
										<b-form class="addcartform commonform" @submit="onSubmit" v-if="user.id >0">
										  <div class="afterlogin">
											<p class="noti_msg">CUSTOM BUILT ORDERS SHOULD CALL CUSTOMER SERVICE AT (800)325-8025 FOR ORDER INFORMATION.</p>
											<div class="samediv quantity">
											  <div class="qtydiv">
												<span @click="decrement()">-</span>
												<input v-model.number="cartform.quantity" type="number" @input="handleInput" step=".01" />
												<span @click="increment()" class="lastspan">+</span>
											  </div>
											</div>
											
											<div class="barbuttons">
											  <input type="hidden" v-model="cartform.user_id">
											<input type="hidden" v-model="cartform.itemid">
											<input type="hidden" v-model="cartform.pc_type">
											<input type="hidden" v-model="cartform.inventcolorid">
											<input type="hidden" v-model="cartform.order_type">
											  <b-button type="submit" class="AddTOCartBtn" variant="dark">Add to cart</b-button>
											  <b-button @click="Showsavetoproject" variant="outline-primary">
												<b-img class="saveproject" src="/shop/images/bookmark.svg" fluid alt="save image"></b-img>
												<b-img
												  class="saveproject white"
												  src="/shop/images/bookmark-white.svg"
												  fluid
												  alt="save image"
												></b-img>Save to Projects
											  </b-button>
											</div>
										  </div>
										</b-form>
									  </div>
									</div>
							</li>
							<li><a href="javascript:;" v-b-toggle.available-color>Additional Colors <b-img class="addicon" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img></a>
								<b-collapse id="available-color" visible accordion="my-accordion_acolors">
									<div class="avail_colors smallimages">
										<a :href="'/shop/hardware/'+result.ITEMID+'/'+result.INVENTCOLORID" v-for="(result, index) in info.AVAILABLECOLORS" :key="index" :class="result.INVENTCOLORID==info.INVENTCOLORID?'forborder selected':'forborder'">
											<div class="color-image">
												<b-img class="smallimg colorimg" :src="result.SMALL_IMAGE" fluid alt="color image"></b-img>
												<span class="colortag">{{result.COLORNAME}}</span>
											</div>
										</a>
									</div>
								</b-collapse>
							</li>
						</ul>
					</div>
                    
                    <div class="specification">
                        
                        <div class="shareus">
                            <p>Share: </p>
                            <ul>
                                <li>
                                    <a :href="facebookshare" target="_blank">
                                        <b-img class="social_icon" alt="facebook" src="/shop/images/facebook.svg"></b-img>
                                    </a>
                                </li>
                                <li>
                                    <a :href="pintrestshare" target="_blank">
                                        <b-img class="social_icon" alt="pinterest" src="/shop/images/pinterest.svg"></b-img>
                                    </a>
                                </li>
                                <li>
                                    <a :href="houzzshare" target="_blank">
                                        <b-img class="social_icon" alt="houzz" src="/shop/images/houzz.svg"></b-img>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="needhelp">
							<h3>Need Help?</h3>
							<div class="callwrite">
								<div class="callus">
								<h4>Call Us</h4>
								<a href="#">
									<b-img src="/shop/images/phone.svg"></b-img>800.325.8025 
								</a>
								<span>Mon - Fri 8:00 AM - 5:00 PM (CDT)</span>
								</div>
								<div class="writeus">
								<h4>Write to Us</h4>
								<a href="mailto:customerservice@rmcoco.com">
									<b-img src="/shop/images/mail.svg"></b-img>customerservice@rmcoco.com
								</a>
								<span>We’ll get back to you within 24 hours.</span>
								</div>
							</div>
						</div>
                    </div>
                </div>
            </div>
        </div>
        <CommonFoot></CommonFoot>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import { ModelSelect } from 'vue-search-select';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import vueMagnifier from "@/components/vue-magnifier";
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    CommonHead,
    CommonFoot,
    ModelSelect,
    vueMagnifier,
    VueSlickCarousel,
	'v-select': vSelect,
	Loading
  },
  mounted() {
	  this.isLoading = true;
      this.$store.dispatch("loadHardwareProductInfo",{itemid:this.$route.params.itemid,inventcolorid:this.$route.params.inventcolorid}).then(productdetails => {
          this.productdetails = productdetails;
		  this.is_dataloaded = true;
		  this.info.SRCSMALL = this.productdetails.PRODUCTIMAGES[0].LARGE_IMAGE;
		  this.info.SRCLARGE = this.productdetails.PRODUCTIMAGES[0].ORIGINAL_IMAGE;
		  this.info.PRODUCTIMAGES = this.productdetails.PRODUCTIMAGES;
		  this.info.ITEMNAME = this.productdetails.ITEMNAME;
		  this.info.COLORNAME = this.productdetails.COLORNAME;
		  this.info.INVENTCOLORID = this.productdetails.INVENTCOLORID;
		  this.info.PRICE = this.productdetails.PRICE;
		  this.info.QTYONHAND = this.productdetails.QtyOnHand;
		  this.info.ITEMID = this.productdetails.ITEMID;
		  this.info.DESCRIPTION = this.productdetails.DESCRIPTION;
		  this.info.AVAILABLECOLORS = this.productdetails.AvailableColors;
		  this.pintrestshare = 'http://pinterest.com/pin/create/button/?url='+window.location.href+'&media=//'+window.location.hostname+this.info.SRCLARGE+'&description='+productdetails.ITEMNAME+'/'+productdetails.COLORNAME;
		  this.houzzshare = 'https://www.houzz.com/imageClipperUpload?link=//'+window.location.hostname+this.info.SRCLARGE+'&source=button&hzid=36769&title='+productdetails.ITEMNAME+'/'+productdetails.COLORNAME+'&ref='+window.location.href;
		  this.breadcrumb[1].text = "All "+productdetails.PC_TYPE;
		  this.breadcrumb[1].href = "/shop/products/"+productdetails.PC_TYPE.toLowerCase();
		  this.breadcrumb[2].text = productdetails.ITEMNAME+"/"+productdetails.COLORNAME;
		  this.isLoading = false;
      });
  },
  data(){
      return{
		cartOrderMsg:"",
		info:{
			SRCSMALL:"",
			SRCLARGE:"",
			PRODUCTIMAGES:[],
			ITEMNAME:"",
			COLORNAME:"",
			INVENTCOLORID:"",
			PRICE:null,
			QTYONHAND:null,
			ITEMID:"",
			DESCRIPTION:"",
			AVAILABLECOLORS:[],
		},
		cartform: new Form({
            itemid : "",
            inventcolorid : "",
            pc_type : "",
			unitid:"yd",
            order_type: "regular",
            quantity :1,
			notes:"",
			user_id:""
        }),
        successtitle:'',
        is_dataloaded: false,
        settings:{
            "dots": false,
            "focusOnSelect": true,
            "infinite": true,
            "speed": 500,
            "slidesToShow": 5,
            "slidesToScroll": 1,
            "touchThreshold": 1,
        },
        productdetails:[],
        form: new Form({
            createclient: "",
            createproject:"",
			product_id:"",
			inventcolorid:"",
			pc_type : "",
			order_type:"",
			notes:"",
			quantity:"",
			user_id:'',
			cart:'',
			error_name:'',
        }),
		form1: new Form({
            client: "",
            project:"",
			product_id:"",
			inventcolorid:"",
			pc_type : "",
			order_type:"",
			notes:"",
			quantity:"",
			user_id:'',
			cart:'',
			error_name:'',
        }),
		form2: new Form({
            client_id: "",
            name:"",
			product_id:"",
			inventcolorid:"",
			pc_type : "",
			order_type:"",
			notes:'',
			quantity:"",
			cart:'',
			user_id:'',
			error_name:'',
        }),
		minicart:{
			items:[]
		},
        showclient:false,
        shownewproject:false,
		shownewclient:false,
        orderstype: [
            { value: 'regular', text: 'Regular'},
        ],
        types: '',
        yard: [
            'yd'
        ],
        size: '',
        clientscart: [
            { value: '1', text: 'James'},
            { value: '2', text: 'Mathew'},
            { value: '3', text: 'John'},
            { value: '4', text: 'Nick'},
        ],
        projects: [
            { value: '1', text: 'Lorem'},
            { value: '2', text: 'Ipsum'},
            { value: '3', text: 'Dolor'},
            { value: '4', text: 'Lorem'},
        ],
        saveprojectcart: [
            { value: '1', text: 'Lorem'},
            { value: '2', text: 'Ipsum'},
            { value: '3', text: 'Dolor'},
            { value: '4', text: 'Lorem'},
        ],
		facebookshare:'https://www.facebook.com/sharer/sharer.php?u='+window.location.href,
		pintrestshare:'',
		houzzshare:'',
		previousPrice:null,
        isLoading: false,
		breadcrumb: [
			{
				text: 'Home',
				href: '/'
			},
			{
				text: 'All Hardware',
				href: '#'
			},
			{
				text: '',
				active: true
			}
        ]
      }
  },
  computed: {
       ...mapGetters(["user"])
  },
  hideModal() {
      this.$refs["modal"].hide();
    },
  methods:{
	getPDF(){
		this.$store.dispatch("loadProducthardwarePDF",{itemid:this.$route.params.itemid,inventcolorid:this.$route.params.inventcolorid}).then(response => {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'product.pdf');
			document.body.appendChild(link);
			link.click();
				
		  });
	},
    increment () {
        let currentqty = Number(this.cartform.quantity) + 1;
      	this.cartform.quantity = Number(currentqty).toFixed(2);
    },
	handleInput(e){
      let stringValue = e.target.value.toString();
      let regex = /^\d*(\.\d{1,2})?$/
      if(!stringValue.match(regex) && this.cartform.quantity!== '') {
        this.cartform.quantity = this.previousPrice;
      }
      this.previousPrice = this.cartform.quantity;
    },
	onSubmit(evt) {
        evt.preventDefault();
        var submit=1;
        this.cartform.itemid = this.productdetails.ITEMID;
        this.cartform.pc_type = this.productdetails.PC_TYPE;
        this.cartform.inventcolorid = this.productdetails.INVENTCOLORID;
        this.cartform.user_id = this.user.accountnumber;
        
        this.$store.dispatch("loadCart",this.user.accountnumber).then(minicart => {
            this.minicart.items = minicart.data.ITEMS;

            if(minicart.data.ITEMS.length>0){
                if(minicart.data.ITEMS[0].PC_TYPE!=this.cartform.pc_type){
                    this.cartOrderMsg=this.cartform.pc_type+" orders cannot be placed with "+minicart.data.ITEMS[0].PC_TYPE+" orders. Please finish placing your "+minicart.data.ITEMS[0].PC_TYPE+" order and then place your "+this.cartform.pc_type+" order separately.";
                    submit=0;
                    this.$refs["cartmodal"].show();
                }
            }
            if(submit==1){   
                this.$store
                .dispatch("AddtoCart", {
                    form: this.cartform
                })
                .then(rsdata => {
					if(rsdata.data.success == false){
						this.cartOrderMsg = rsdata.data.message;
						this.$refs["cartmodal"].show();
					}else{	
						this.$notify({
							text: "Product added to cart",
							type: "success"
						});
						this.isLoading = true;
						this.$store.dispatch("loadCart",this.user.accountnumber).finally(() => {
							this.isLoading = false;
						});
					}
                })
                .catch(error => {
                    if (this.cartform.hasErrors()) {
                        this.$notify({
                            text:
                            "There is a validation error. Please correct the fields outlined in red and try again.",
                            type: "error"
                        });
                    } else {
                        this.$notify({
                            text: "Something went wrong!",
                            type: "error"
                        });
                    }
                });
            }
        });
    },
	Submit1Popup(evt) {
      evt.preventDefault();
	  
	  this.form1.product_id = this.productdetails.ITEMID;
	  this.form1.inventcolorid = this.productdetails.INVENTCOLORID;
	  this.form1.pc_type = this.productdetails.PC_TYPE;
	  this.form1.order_type = this.cartform.order_type;
	  this.form1.notes=this.cartform.notes
	  this.form1.quantity = this.cartform.quantity;
	  
	  this.isLoading = true;
       this.$store.dispatch("AddProductToProject", {
			form: this.form1
		  }).then(response => {
         if (response.data.success) {
		 this.form1.error_name="";
           this.$notify({
             text: "Product added successfully",
             type: "success"
           });
           this.form1 = new Form({
             client: null,
			 project: null,
			 error_name:'',
           });
		   
		   this.$refs["popupmodal"].hide();
		   this.successtitle="Product added successfully";
		   this.$refs["successmodal"].show();
		   
		   
         } else {
           this.$notify({
             text: "please try again!",
             type: "error"
           });
		   
		   this.form1.error_name=response.data.error;
         }
       });
       this.isLoading = false;
	},
	Submit2Popup(evt) {
      evt.preventDefault();
	  
	  this.form2.product_id = this.productdetails.ITEMID;
	  this.form2.inventcolorid = this.productdetails.INVENTCOLORID;
	  this.form2.pc_type = this.productdetails.PC_TYPE;
	  this.form2.order_type = this.cartform.order_type;
	  this.form2.notes=this.cartform.notes;
	  this.form2.quantity = this.cartform.quantity;
	  
	  this.isLoading = true;
       this.$store.dispatch("AddProject", {
			form: this.form2
		  }).then(response => {
         if (response.data.success) {
		 this.form2.error_name="";
           this.$notify({
             text: "Product added successfully",
             type: "success"
           });
           this.form2 = new Form({
             client_id: null,
			 name: null,
			 error_name:'',
           });
		   
		   this.$refs["popupmodal"].hide();
		   this.successtitle="Product added successfully";
		   this.$refs["successmodal"].show();
		   
         } else {
           this.$notify({
             text: "please try again!",
             type: "error"
           });
		   this.form2.error_name=response.data.error;
         }
       });
       this.isLoading = false;
	},
	Submit3Popup(evt) {
      evt.preventDefault();
	  
	  this.form.product_id = this.productdetails.ITEMID;
	  this.form.inventcolorid = this.productdetails.INVENTCOLORID;
	  this.form.pc_type = this.productdetails.PC_TYPE;
	  this.form.order_type = this.cartform.order_type;
	  this.form.notes=this.cartform.notes;
	  this.form.quantity = this.cartform.quantity;
	  this.form.user_id = this.user.accountnumber;
	  
	  this.isLoading = true;
       this.$store.dispatch("AddClientAndProject", {
			form: this.form
		  }).then(response => {
         if (response.data.success) {
			this.form.error_name="";
			//update clients dropdown
			this.LoadClients();
			
           this.$notify({
             text: "Product added successfully",
             type: "success"
           });
           this.form = new Form({
             createclient: null,
			 createproject: null,
			 error_name:'',
           });
		   
		   this.$refs["popupmodal"].hide();
		   this.successtitle="Product added successfully";
		   this.$refs["successmodal"].show();
		   
		   
         } else {
           this.$notify({
             text: "please try again!",
             type: "error"
           });
		    this.form.error_name=response.data.error;
         }
       });
       this.isLoading = false;
	},
    decrement () {
      if(this.cartform.quantity < 1) {
        alert('Negative quantity not allowed')
      } else {
        let currentqty = Number(this.cartform.quantity) - 1;
        this.cartform.quantity = Number(currentqty).toFixed(2);
		//if(this.productdetails.QtyOnHand<this.cartform.quantity){$(".noti_msg").removeClass("HideNoti");}else{$(".noti_msg").addClass("HideNoti");}
      }
    },
	
	Showsavetoproject(){
		if(this.cartform.order_type){
			this.resetModelForm();
			this.$refs["modal"].show();
		}else{
			$(".ordertype.type").append("<span class='error-msg'>Required Field</span>");
		}
	},
	resetModelForm(){
		$(".ordertype.type .error-msg").remove();
		$(".savetoclient .error-msg").remove();
		this.showclient=false;
		this.shownewproject=false;
		this.shownewclient=false;
		//reset forms
		this.form.createclient= "";
		this.form.createproject="";
		this.form.product_id="";
		this.form.inventcolorid="";
		this.form.pc_type="";
		this.form.order_type="";
		this.form.notes="";
		this.form.quantity="";
		this.form.user_id='';
		this.form.cart='';
	
	
		this.form1.client= "";
		this.form1.project="";
		this.form1.product_id="";
		this.form1.inventcolorid="";
		this.form1.pc_type="";
		this.form1.order_type="";
		this.form1.notes="";
		this.form1.quantity="";
		this.form1.user_id='';
		this.form1.cart='';
	
		this.form2.client_id= "";
		this.form2.name="";
		this.form2.product_id="";
		this.form2.inventcolorid="";
		this.form2.pc_type="";
		this.form2.order_type="";
		this.form2.notes="";
		this.form2.quantity="";
		this.form2.user_id='';
		this.form2.cart='';
	},
	getProjects(){
		if(this.form1.client){
			$(".showProject").show();
			this.$store.dispatch("LoadClientProjects",this.form1.client).then(loadprojects => {
				  this.projects = loadprojects.data;
			  });
		}else{
			$(".showProject").hide();
		}
	},
	showProject1(){
		if(this.form2.client_id){
			$(".showProject1").show();
		}else{
			$(".showProject1").hide();
		}
	},
	showProject2(){
		if(this.form.createclient){
			$(".showProject2").show();
		}else{
			$(".showProject2").hide();
		}
	},
	LoadClients(){
		this.$store.dispatch("LoadClient",this.user.accountnumber).then(loadclients => {
			  this.clientscart = loadclients.data;
		});
	},
	
  }
}
</script>
<style>
.showProject,.showProject1,.md-field.md-theme-default.showProject2{
	display:none;
}
.singlecontent h2[data-v-singlehardware]{
    width: 63%;
}
</style>